import { z } from "zod";

export const deletePushTokenSchema = z.object({
	token: z.string(),
});

export type DeletePushTokenSchema = z.infer<typeof deletePushTokenSchema>;
